<style>
  .role-scope-setting .el-tag + .el-tag {
    margin-left: 10px;
    margin-top: 4px;
  }
</style>
<template>
  <div v-if="menu.menuId" class="role-scope-setting" style="border: 1px solid #ebeef5; margin-top: 10px; padding: 10px;">
    <h4>添加角色（菜单：{{ menu.menuName }}）</h4>
    <el-form :inline="true">
      <el-form-item label="站点">
        <el-select v-model="selectWebSite" placeholder="请选择站点" @change="onSelectSiteChange" size="mini">
          <el-option v-for="webSite in webSites" :key="webSite.id" :label="webSite.name" :value="webSite.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="selectSiteRole" placeholder="请选择角色" size="mini">
          <el-option v-for="role in siteRoles" :key="role.roleId" :label="role.roleName" :value="role.roleId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="addRoleScope" size="mini">添加</el-button>
      </el-form-item>
    </el-form>
    <h4>已设定的角色范围</h4>
    <el-table :data="menuRoleScope" style="width: 100%; border: 1px solid #ebeef5;">
      <el-table-column prop="siteName" label="站点" width="200"></el-table-column>
      <el-table-column prop="roleScope" label="角色范围">
        <template slot-scope="scope">
          <el-tag v-for="role in scope.row.roleScope"
                  :key="role.roleId" closable size="medium"
                  @close="handleRoleRemove(role)">{{ role.roleName }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
  import util from '../../libs/util'

  export default {
    name: 'menu-role-scope',
    props: {
      menu: {
        type: Object,
        default() {
          return {}
        }
      },
      webSites: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return {
        siteRoleMap: {},
        selectWebSite: '',
        selectSiteRole: '',
        siteRoles: [],
        menuRoleScope: []
      }
    },
    created() {
      this.loadSiteRoleMap()
    },
    methods: {
      loadSiteRoleMap() { // 加载所有站点的角色
        util.ajax.post('/superAdmin/permissionManage/getAllSiteRoles').then((res) => {
          this.siteRoleMap = res.data.data
        }).catch((err) => {
          console.error(err)
        })
      },
      onSelectSiteChange() {
        this.loadRoleSelectData()
      },
      loadRoleSelectData() {
        this.selectSiteRole = ''
        if (this.selectWebSite) {
          this.siteRoles = this.siteRoleMap[this.selectWebSite]
        } else {
          this.siteRoles = []
        }
      },
      addRoleScope() {
        if (!this.menu.menuId) {
          this.$notify.info({title: '提示', message: '请先选择菜单'})
          return
        }
        if (!this.selectWebSite) {
          this.$notify.info({title: '提示', message: '请选择站点'})
          return
        }
        if (!this.selectSiteRole) {
          this.$notify.info({title: '提示', message: '请选择角色'})
          return
        }
        let params = {
          menuId: this.menu.menuId,
          siteId: this.selectWebSite,
          roleIds: this.selectSiteRole
        }
        util.ajax.post('/superAdmin/gridManage/addGridMenuRoleScope', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '添加成功'})
            this.loadMenuRoleScope()
          } else {
            this.$notify.info({title: '提示', message: res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '添加失败'})
          console.error(err)
        })
      },
      handleRoleRemove(data) {
        let params = {
          menuId: this.menu.menuId,
          siteId: data.siteId,
          roleCodes: data.roleCode
        }
        util.ajax.post('/superAdmin/gridManage/removeGridMenuRoleScope', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '删除成功'})
            this.loadMenuRoleScope()
          } else {
            this.$notify.info({title: '提示', message: res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '添加失败'})
          console.error(err)
        })
      },
      loadMenuRoleScope() {
        if (!this.menu.menuId) {
          return
        }
        let params = {menuId: this.menu.menuId}
        util.ajax.post('/superAdmin/gridManage/getMenuRoleScope', {params}).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.menuRoleScope = res.data.data
          } else {
            this.$notify.warning({title: '警告', message: res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.$notify.error({title: '错误', message: '错误，获取菜单角色范围失败'})
          console.error(err)
        })
      }
    },
    watch: {
      'menu.menuId': function (newValue) {
        this.loadMenuRoleScope()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/super-admin/grid-manage/menu-role-scope.vue